import styled from 'styled-components';

export const UploadPreview = styled.div`
  padding-bottom: 24px;
`;
